import * as mqtt from 'mqtt/dist/mqtt';
import dayjs from 'dayjs';

import {globalSlice, callTypes} from './Slice';
import store from '../Store';

const {actions} = globalSlice;

export const setRandom = () => (dispatch) => {
  dispatch(actions.setRandom());
};

export const clearMessages = () => (dispatch) => {
  dispatch(actions.clearMessages());
};

export const mqttDisconnect = () => (dispatch) => {
  let state = store.getState();

  if (state.global.client) {
    try {
      state.global.client.end(false, () => {
        console.log('disconnected successfully');
        dispatch(actions.setDisconnect());
      });
    } catch (error) {
      console.log('disconnect error:', error);
    }
  }
  // dispatch(actions.setDisconnect());
};

export const unSub = (subscription) => (dispatch) => {
  let state = store.getState();

  if (state.global.client) {
    const {topic, qos} = subscription;
    state.global.client.unsubscribe(topic, {qos}, (error) => {
      if (error) {
        console.log('Unsubscribe error', error);
        return;
      }
      console.log(`unsubscribed topic: ${topic}`);
      dispatch(actions.unSub(subscription));
    });
  }
};

export const sub = (subscription) => (dispatch) => {
  let state = store.getState();

  if (state.global.client) {
    const {topic, qos} = subscription;
    // subscribe topic
    state.global.client.subscribe(topic, {qos}, (error) => {
      if (error) {
        console.log('Subscribe to topics error', error);
        return;
      }
      console.log(`Subscribe to topics: ${topic}`);
      dispatch(actions.sub(subscription));
    });
  }
};

export const listenNotifications = () => async (dispatch) => {
  dispatch(actions.setConnectStatus('Đang kết nối'));

   const protocol = 'wss';
  const host = 'queencrown.hanhchinhcong.net';
  const port = 443;
 /*  const protocol = 'ws';
  const host = '192.168.2.95';
  const port = 5885; */
  const mqttOption = {
    clientId: 'queen_' + Math.random().toString(16).substring(2, 8),
    username: 'admin',
    password: '12345',
    clean: true,
    reconnectPeriod: 1000, // ms
    connectTimeout: 30 * 1000, // ms
  };

  const client = mqtt.connect(`${protocol}://${host}:${port}/mqtt`, mqttOption);

  dispatch(actions.setClient(client));

  if (client) {
    client.on('connect', () => {
      dispatch(actions.setConnectStatus('Đã kết nối'));
      console.log('connection successful');
    });

    client.on('error', (err) => {
      console.error('Connection error: ', err);
      client.end();
    });

    client.on('reconnect', () => {
      dispatch(actions.setConnectStatus('Đang kết nối lại'));
    });

    client.on('message', (topic, message) => {
      const payload = {topic, message: message.toString(), time: dayjs().format('YYYY-MM-DD HH:mm:ss')};
      //setPayload(payload);
      dispatch(actions.setMessages(payload));
      console.log(`received message: ${message} from topic: ${topic}`);
    });
  }
};
